<template>
  <div
    class="tw-margin-small-top uk-margin-bottom tw-text-small tw-text-muted"
    style="margin-left:3px;"
  >
    <div v-if="hasBrowserData">
      <Alert>
        <div class="uk-text-bold uk-margin-small-bottom">
          {{ $t('static_translation.daten-aus-browser') }}
        </div>
        <Button
          type="default"
          size="small"
          @click="resetForm"
        >
          {{ $t('static_translation.reset-form') }}
        </Button>
        &nbsp;
        <Button
          type="default"
          size="small"
          @click="resetBrowser"
        >
          {{ $t('static_translation.delete-browser') }}
        </Button>
      </Alert>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      hasBrowserData: state => state.store.hasBrowserData
    })
  },
  methods: {
    resetForm () {
      this.$store.commit('resetForm')
    },
    resetBrowser () {
      this.$store.commit('resetForm')
      this.$store.dispatch('resetBrowser')
    }
  }
}
</script>
